module.exports = __webpack_public_path__ + "static/media/maxbill-drawing.d56cba38.jpg";